enum CalendarExportRoomNameExportType {
	NONE = 'NONE',
	ROOM_NAME = 'ROOM_NAME',
	ROOM_TYPE = 'ROOM_TYPE',
}

export default CalendarExportRoomNameExportType;
